export default __webpack_public_path__ + "static/artgifts-b9dccfb730d510389ecfe9ac68629e00.webp";